import React, { useEffect, useState } from "react";

import client from "apollo";
import locales from "locales";
import decode from "jwt-decode";
import MUIThemeProvider from "theme";
import { jwtDecode } from "jwt-decode";

import { hasRequiredRole } from "helpers";
import { IntlProvider } from "react-intl";
import { DirectionProvider } from "providers";
import { signOut } from "toolkits/redux/auth";
import { StyledChart } from "components/Chart";
import { ToastContainer } from "react-toastify";
import { ApolloProvider } from "@apollo/client";
import { ScrollToTop, SplashScreen } from "components";
import { useDispatch, useSelector } from "react-redux";
import {
  UserRoutes,
  DoctorRoutes,
  LabAdminRoutes,
  UnitAdminRoutes,
  SuperAdminRoutes,
  LabAdminDemoRoutes,
  UnitAdminDemoRoutes,
  AuthenticationRoutes,
} from "routing";

import "styles/globals.css";
import "react-toastify/dist/ReactToastify.css";
import Verifications from "screens/Verifications";

// ----------------------------------------------------------------------

function AppRoutes({ roles, isDemo }) {
  if (hasRequiredRole(["superadmin", "operator"], roles)) {
    return <SuperAdminRoutes />;
  }
  if (hasRequiredRole(["labManager", "labOperator"], roles)) {
    if (isDemo) {
      return <LabAdminDemoRoutes />;
    }
    return <LabAdminRoutes />;
  }
  if (hasRequiredRole(["unitManager", "unitOperator"], roles)) {
    if (isDemo) {
      return <UnitAdminDemoRoutes />;
    }
    return <UnitAdminRoutes />;
  }
  if (hasRequiredRole(["doctor"], roles)) {
    return <DoctorRoutes />;
  }
  return <UserRoutes />;
  // return <>Nothing</>;
}

function Routing() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const { isAuthenticated, userToken, userInfo, activeRole } = useSelector(
    (state) => state.auth
  );

  useEffect(() => {
    if (userToken === null || decode(userToken).exp < Date.now() / 1000) {
      dispatch(signOut());
    }
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1200);
    return () => clearTimeout(timer);
  }, [isAuthenticated]);

  if (!loading) {
    if (isAuthenticated) {
      if (activeRole && activeRole?.status === "confirmed") {
        return (
          <AppRoutes
            roles={userInfo?.roles}
            isActive={userInfo?.isActive}
            isDemo={Boolean(+activeRole?.is_demo)}
          />
        );
      }
      return <Verifications />;
    }
    return <AuthenticationRoutes />;
  }
  return <SplashScreen />;
}

export default function App() {
  const {
    language: { language, direction },
  } = useSelector((state) => state.setting);
  return (
    <MUIThemeProvider>
      <DirectionProvider direction={direction}>
        <IntlProvider
          defaultLocale="fa"
          locale={language}
          messages={locales[language]}
        >
          <ToastContainer
            draggable
            closeButton={false}
            style={{ marginBottom: 56 }}
            bodyStyle={{ direction }}
            position="top-center"
          />
          <ApolloProvider client={client}>
            <ScrollToTop />
            <StyledChart />
            <Routing />
          </ApolloProvider>
        </IntlProvider>
      </DirectionProvider>
    </MUIThemeProvider>
  );
}
